import '@babel/polyfill/noConflict';
import './vendor/modernizr';
import objectFitImages from 'object-fit-images';

import { AnimateObserver } from './lib/animate-observer';
import { Sticky } from './lib/sticky';
import { LazyLoad } from './lib/lazy-load';
import { Carousel } from './lib/carousel';

const eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];

const loadJS = () => {

    // Remove event listeners
    eventList.forEach(event => {
        document.removeEventListener(event, loadJS);
    });

    // Get scripts with data-src attribute
    const scripts = document.querySelectorAll('script[data-src]');

    // Loop through scripts and replace with src attribute
    Array.from(scripts).forEach(script => {
        script.src = script.dataset.src;
    });
}

// For each event type, add event listener to window
eventList.forEach(event => {
    window.addEventListener(event, loadJS, {passive: true});
});

objectFitImages();

const animate = new AnimateObserver();
animate.init();

const carousel = new Carousel();
carousel.init();

const sticky = new Sticky();
sticky.init();

const lazy = new LazyLoad();
lazy.init();